// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Indicator_indicator__14QRW","indicator-green":"Indicator_indicator-green__GqZRH","indicator-wrapper":"Indicator_indicator-wrapper__17EZr"};